// gatsby-browser.js
import React from "react"
import { LanguageProvider } from "./src/contexts/LanguageContext"

let Prism = null

export const onClientEntry = () => {
  // Prismの初期化を遅延
}

// 全ページを LanguageProvider でラップ
export const wrapPageElement = ({ element, props }) => {
  const lang = props.pageContext?.lang || "ja"
  return <LanguageProvider lang={lang}>{element}</LanguageProvider>
}

// ページ遷移時にスクロール位置をトップにリセット
export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition
}) => {
  // 常にページトップにスクロール
  window.setTimeout(() => window.scrollTo(0, 0), 0)
  return false
}

// ルート変更時にPrismを動的にロード
export const onRouteUpdate = ({ location }) => {
  // ブログ記事ページまたはNotesページでのみPrismをロード
  const isBlogPost = /^\/(ja|en)\/blog\//.test(location.pathname) && location.pathname.split('/').filter(Boolean).length > 2
  const isNotesPage = location.pathname.includes('/notes/') && location.pathname.split('/').filter(Boolean).length > 2
  
  if ((isBlogPost || isNotesPage) && !Prism) {
    // Prismと関連モジュールを動的にインポート
    Promise.all([
      import('prismjs'),
      import('prismjs/themes/prism-okaidia.css'),
      import('prismjs/plugins/toolbar/prism-toolbar.css'),
      import('prismjs/plugins/line-numbers/prism-line-numbers.css')
    ]).then(([prismModule]) => {
      Prism = prismModule.default
      
      // 言語サポートを動的にロード
      return Promise.all([
        import('prismjs/components/prism-csharp'),
        import('prismjs/components/prism-javascript'),
        import('prismjs/components/prism-python'),
        import('prismjs/components/prism-bash'),
        import('prismjs/components/prism-css'),
        import('prismjs/components/prism-gdscript'),
        import('prismjs/plugins/toolbar/prism-toolbar'),
        import('prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard'),
        import('prismjs/plugins/line-numbers/prism-line-numbers')
      ])
    }).then(() => {
      // Prismをwindowオブジェクトに設定
      if (typeof window !== 'undefined') {
        window.Prism = Prism
        // 既存のコードブロックをハイライト
        setTimeout(() => {
          if (Prism && Prism.highlightAll) {
            Prism.highlightAll()
          }
        }, 100)
      }
    }).catch(err => {
      console.error('Failed to load Prism:', err)
    })
  } else if (Prism && (isBlogPost || isNotesPage)) {
    // 既にロード済みの場合はハイライトのみ実行
    setTimeout(() => {
      if (Prism.highlightAll) {
        Prism.highlightAll()
      }
    }, 100)
  }
}